module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-94c0c4e617ccd395a266f9fdfc4a2687.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }